<svelte:head>
    <link href="//cdn.quilljs.com/1.3.6/quill.snow.css" rel="stylesheet">
</svelte:head>

<script>
    /* https://quilljs.com/docs/configuration/ */
    import {quill} from 'svelte-quill';
    import {onMount} from "svelte";
    import {createEventDispatcher} from 'svelte/internal';

    export let id = '';
    export let lang_id = '';
    export let text = '';

    let editor;
    let htmlText = text;


    const dispatch = createEventDispatcher();

    const toolbarOptions = [
        // [{'header': 2}, {'header': 3}, "link"],
        [{'header': [false, 2, 3, 4, 5]}],
        ["bold", "italic", "underline", "strike"],
        [{list: "bullet"}, {list: "ordered"}],
        [{align: 'right'}, {align: 'center'}],
        ["clean"]
    ];

    const onTextChange = event => {
        dispatch("change", {id, lang_id, text: event.detail.html});
    }

    onMount(async () => {
        let Quill = new quill(editor, {
            modules: {
                toolbar: toolbarOptions
            },
            theme: "snow",
            placeholder: "κείμενο"
        });
    });
</script>

<div class="editor-wrapper">
    <div bind:this={editor} on:text-change={ onTextChange }>{@html htmlText }</div>
</div>

<style>
    :global(.ql-snow .ql-editor h2) {
        /*font-size: 3.5em !important;*/
    }
</style>